import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { environment } from 'environments/environment';
import { ROUTES } from './app.routes';

import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { ViegaCommonModule } from '../viega-common';

import { AppComponent } from './app.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { NoContentComponent } from './no-content';

import '../viega-common/index.scss';
import '../styles/styles.scss';

@NgModule({
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        RouterModule.forRoot(
            ROUTES, {
                useHash: true
            }
        ),
        CoreModule.forRoot(),
        SharedModule,
        ViegaCommonModule,
    ],
    declarations: [
        AppComponent,
        WelcomeComponent,
        NoContentComponent,
    ],
    providers: [
        environment.ENV_PROVIDERS,
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts